// extracted by mini-css-extract-plugin
export var editInput = "_ev-0";
export var editInputCompact = "_ev-2";
export var editInputLarge = "_ev-1";
export var editInputSmall = "_ev-3";